import { Expose } from 'class-transformer';
import { DropdownModel } from 'src/app/core/data/model';

export class QuranSurah extends DropdownModel {
  @Expose() id: string;
  @Expose() numberOfVerses: string;
  @Expose() name: string;
  override get dropDownDisplayName(): string {
    return this.name;
  }
  override get dropDownValue(): Object {
    return this;
  }
}
